import {
  BasicButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  GhostButton,
  Modal,
  PrimaryButton,
  SecondaryTopNav,
  Text,
} from "@certn/cascadia-react";
import { useContext, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { WorkableIntegrationContext } from "../WorkableIntegrationContext";

interface Props {
  onComplete?: () => void;
  isDisabled?: boolean;
  submitting?: boolean;
}

export function WorkableIntegrationStepHeader({
  onComplete,
  isDisabled,
  submitting,
}: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { goToPrevStep, currentStep } = useContext(WorkableIntegrationContext);
  const [isCancelModalVisible, setCancelModalVisible] = useState(false);

  const showCancelModal = () => {
    setCancelModalVisible(true);
  };

  const handleCancelConfirm = () => {
    navigate("/settings/ats-integrations");
  };

  const handleCancelCancel = () => {
    setCancelModalVisible(false);
  };

  const steps = [
    { buttonLabel: t("Next step") },
    { buttonLabel: t("Complete setup") },
  ];

  return (
    <>
      <SecondaryTopNav
        testID="ats-integration-setup-top-nav"
        leftIcon={currentStep === 0 ? "close" : "arrow_back"}
        onleftIconOnPress={currentStep === 0 ? showCancelModal : goToPrevStep}
      >
        {currentStep > 0 && (
          <GhostButton
            onPress={showCancelModal}
            testID="ats-integration-setup-top-nav-cancel-button"
          >
            {t("Cancel")}
          </GhostButton>
        )}
        <PrimaryButton
          onPress={onComplete}
          isDisabled={isDisabled}
          isLoading={submitting}
          testID="ats-integration-setup-top-nav-connect-button"
        >
          {steps[currentStep].buttonLabel}
        </PrimaryButton>
      </SecondaryTopNav>
      <Modal isOpen={isCancelModalVisible}>
        <Dialog width="560px">
          <DialogHeader onClose={handleCancelCancel}>
            {t("Cancel integration")}
          </DialogHeader>
          <DialogContent>
            <Text style="form/body-primary">
              <Trans>
                You are about to leave the integration process. Any information
                you have entered so far will be lost.
              </Trans>
            </Text>
          </DialogContent>
          <DialogFooter>
            <BasicButton onPress={handleCancelCancel}>
              {t("Go back")}
            </BasicButton>
            <PrimaryButton
              onPress={handleCancelConfirm}
              testID="cancel-integration-confirm-button"
            >
              {t("Cancel integration")}
            </PrimaryButton>
          </DialogFooter>
        </Dialog>
      </Modal>
    </>
  );
}
